<style lang="scss" src='./CourseNewStation.scss' scoped></style>
<template src="./CourseNewStation.html"></template>

<script>
  import { saveWeatherStation, updateWeatherStation, validateSnStationAvailable } from '@/api/index';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import { mapMutations, mapState } from 'vuex';
  import { pick } from 'lodash';
  import { Models } from 'gw-js-lib';

  extend('required', required);

  export default {
    name: 'CourseNewStation',
    components: {
      ValidationProvider,
      ValidationObserver,
    },

    data() {
      return {
        station: Models.M_weatherStation(),
        uom: 'HEIGHT'
      };
    },

    computed: {
       ...mapState('CourseSetup', {
        course: (state) => state.setupData.course,
        stations: (state) => state.setupData.stations,
        loading: (state) => state.loading,
        editingStation: (state) => state.editingStation,
        stationSelected: (state) => state.stationSelected,
      }),
    },

    watch: {
    },

    methods: {
      cleanForm() {
        this.station = Models.M_weatherStation();
        this.$refs.validator.reset();
      },

      async validateStation() {
        const validForm = await this.$refs.validator.validate().then((v) => v);
        if (validForm) {
          this.setLoading({savingStation: true});
          let station = null;

          if (this.editingStation) {
            station = await this.fnUpdateWeatherStation();
            this.updateStation(station);
          } else {
            if(! this.G_isEmptyArr(this.stations)) {
              const stationAlreadyAdded = this.stations.find(s => s.device_sn == this.station.device_sn);
              if (stationAlreadyAdded && stationAlreadyAdded.device_sn) {
                this.cleanForm();
                this.setShowNewStationPage(false);
                return;
              }
            }
            station = await this.fnSaveStation();
            this.addStation(station);
          }

          this.cleanForm();
          this.setLoading({savingStation: false});
          this.setShowNewStationPage(false);
        }
      },

      async fnSaveStation() {
        if (this.course && this.course.course_id) {
          const station = await saveWeatherStation(this.course.course_id, this.station).catch(() => {});
          return station;
        }
        return {...this.station, time_created: new Date()};
      },

      async fnUpdateWeatherStation() {
        if (this.station && this.station.station_id) {
          const stationAux = {...pick(this.station, Object.keys(Models.M_weatherStation()))};
          const station = await updateWeatherStation(this.station.station_id, stationAux);
          return station;
        } else {
          return this.station;
        }
      },

      ...mapMutations('CourseSetup', ['setLoading', 'setShowNewStationPage', 'addStation', 'updateStation']),

    },

    activated() {
      this.setLoading({savingStation: false});
      this.$refs.validator.reset();
    },

    beforeCreate() {
    },

    mounted() {
      this.setLoading({savingStation: false});
      if (this.editingStation) {
        this.station = this.stationSelected;
      } else {
        this.station = Models.M_weatherStation();
      }
    },

    beforeDestroy() {
    },
  };

</script>
